export const footerMenu = [
    {
        title: 'محصولات',
        items: [
            {
                title: 'مرکز تلفن ابری',
                icon: 'nava-icon:products-cloud-pbx',
                path: '/products/cloud-pbx/', 
            },
            {
                title: 'خط تلفن اینترنتی',
                icon: 'nava-icon:products-internet-phone',
                path: '/products/internet-phone/', 
            },
            {
                title: 'پنل پیامکی',
                icon: 'nava-icon:products-sms',
                path: '/products/sms/', 
            },
            {
                title: 'چت‌آنلاین',
                icon: 'nava-icon:products-webchat',
                path: '/products/webchat/', 
            },
            {
                title: 'فکس آنلاین',
                icon: 'nava-icon:products-fax',
                path: '/products/fax/', 
            },
            {
                title: 'CRM آنلاین',
                icon: 'nava-icon:products-crm',
                path: '/products/crm/', 
            },
            // {
            //     title: 'ارزیابی عملکرد',
            //     icon: 'solar:clipboard-check-linear',
            //     path: '', 
            // },
            {
                title: 'اپلیکیشن اختصاصی',
                icon: 'nava-icon:products-nava-app',
                path: '/products/dedicated-application/', 
            },
            // {
            //     title: 'پنل مدیریتی',
            //     icon: 'solar:laptop-minimalistic-linear',
            //     path: '/products/management-dashboard/', 
            // },
            {
                title: 'شماره‌های ابری مخابرات استان تهران',
                icon: 'nava-icon:tci-linear',
                path: '/rond/', 
            },
            // {
            //     title: 'خطوط 4 رقمی مخابرات',
            //     icon: 'nava-icon:tci-linear',
            //     path: '/products/4-digit-line/', 
            // },
            // {
            //     title: 'خطوط 5 رقمی مخابرات',
            //     icon: 'nava-icon:tci-linear',
            //     path: '/products/5-digit-line/', 
            // },
        ]
    },
    {
        title: 'ارتباط با ما',
        items: [
        {
            title: 'درباره ما',
            icon: 'nava-icon:navatel-linear',
            path: '/about-us/', 
        },
        {
            title: 'مدیر عامل و معاونین',
            icon: 'solar:users-group-two-rounded-linear',
            path: '/managers/', 
        },
        // {
        //     title: 'نمایشگاه‌ها و رویدادها',
        //     icon: 'solar:shop-minimalistic-linear',
        //     path: '', 
        // },
        {
            title: 'تماس با ما',
            icon: 'solar:phone-calling-linear',
            path: '/contact-us/', 
        },
        {
            title: 'فرم درخواست نمایندگی',
            icon: 'solar:pen-new-square-linear',
            path: '/sales-agent/', 
        },
        {
            title: 'پشتیبانی',
            icon: 'solar:headphones-round-sound-linear',
            path: '/support/', 
        },
        ]
    },
    {
        title: 'منابع',
        items: [
            {
                title: 'بلاگ',
                icon: 'solar:notebook-bookmark-linear',
                path: 'https://navatel.ir/blog/', 
                targetBlank: true,
            },
            // {
            //     title: 'پایگاه دانش',
            //     icon: 'solar:square-academic-cap-2-linear',
            //     path: '/products/cloud-pbx/', 
            // },
            // {
            //     title: 'سوالات متداول',
            //     icon: 'solar:question-square-linear',
            //     path: '/products/cloud-pbx/', 
            // },
            {
                title: 'کاتالوگ',
                icon: 'solar:documents-linear',
                path: 'https://navatel.ir/Digital-Catalogue/', 
            },
            // {
            //     title: 'مستندات API',
            //     icon: 'solar:code-file-linear',
            //     path: '/products/cloud-pbx/', 
            // },
        ]
    },
    // {
    //     title: 'شرکای تجاری ',
    //     items: [
    //         {
    //             title: 'مرکز تماس ابری مخابرات ایران (متاما)',
    //             icon: 'nava-icon:tci-linear',
    //             path: '/metama/', 
    //         },
    //         {
    //             title: 'ایرانسل',
    //             icon: 'nava-icon:irancell-linear',
    //             path: '/products/cloud-pbx/', 
    //         },
    //         {
    //             title: 'آسیاتک',
    //             icon: 'nava-icon:asiatech-linear',
    //             path: '/products/cloud-pbx/', 
    //         },
    //         {
    //             title: 'دفاتر پیشخوان دولت',
    //             icon: 'nava-icon:pishkhan-linear',
    //             path: '/products/cloud-pbx/', 
    //         },
    //     ]
    // },
];

export const socialLinks = [
    { path: 'http://ble.ir/navatel1', icon: 'nava-icon:bale-bold' },
    { path: 'https://www.linkedin.com/company/mynavatel/', icon: 'cib:linkedin' },
    { path: 'https://t.me/navatelir', icon: 'cib:telegram' },
    { path: 'http://www.youtube.com/@navatel1944', icon: 'cib:youtube' },
    { path: 'https://www.aparat.com/Navatel', icon: 'nava-icon:aparat-bold' },
    { path: 'https://www.instagram.com/navatel.ir/', icon: 'cib:instagram' },
];

export const trustImages = [
    { 
        title: 'ساماندهی',
        path: 'https://logo.samandehi.ir/Verify.aspx?id=272681&p=uiwkjyoeuiwkgvkamcsirfth', 
        img: '/img/new/footer/samandehi.webp' 
    },
    { 
        title: 'اینماد',
        path: 'https://trustseal.enamad.ir/?id=316143&Code=GZS45wVZZYKd4Se99ieH', 
        img: '/img/new/footer/enamad.webp' 
    },
    { 
        title: 'ویپ',
        path: 'https://195.cra.ir/', 
        img: '/img/new/footer/samane-195.webp' 
    },
    { 
        title: 'سازمان نظام صنفی',
        path: 'https://tehran.irannsr.org/fa/page/104366-%D9%85%D8%B4%D8%A7%D9%87%D8%AF%D9%87-%D8%A7%D8%B9%D8%B6%D8%A7.html?ctp_id=1086&id=33940', 
        img: '/img/new/footer/nezam-senfi.webp' 
    },
];

export const contactInfo = [
    {
        text: 'تهران، خیابان شریعتی، سه راه طالقانی، ابتدای خیابان خواجه نصیر الدین طوسی، پلاک ۲۴۷',
        icon: 'solar:map-point-linear',
    },
    {
        text: 'تلفن دفتر مرکزی : 82800000-021',
        icon: 'solar:phone-calling-linear',
    },
    {
        text: 'پشتیبانی فنی به‌صورت ۲۴ ساعته و ۷ روز هفته (24/7)',
        icon: 'solar:headphones-round-linear',
    },
];